module.exports = __webpack_public_path__ + "img/logo-viva.09c01312.png";